import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGlassWater: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"glass-water, drink"} maskId="square-filled-radius-0-stroke-1-IconGlassWater"><path fillRule="evenodd" clipRule="evenodd" d="M19.9961 3.55859L17.9443 21H6.05566L4.00391 3.55859L3.9375 3H20.0625L19.9961 3.55859ZM5.63086 8.84375C7.846 8.18249 10.0409 8.61353 12.0947 9.00879C14.2836 9.43003 16.3171 9.80679 18.3359 9.11426L18.9385 4H5.06152L5.63086 8.84375Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGlassWater;
